import PropTypes from 'prop-types';
import { createRoot } from 'react-dom/client';
import { getGlobalWalkthroughManager, useManager } from './walkthrough';
import Table from '../utils/table';

function UpdateStatusLink({ walkthrough, status, text }) {
    return (
        <button
            onClick={() => {
                walkthrough.updateState(status, '');
            }}
        >
            {text}
        </button>
    );
}

UpdateStatusLink.propTypes = {
    walkthrough: PropTypes.object.isRequired,
    status: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

function App({ manager }) {
    useManager(manager);

    if (!manager.isLoaded) return <p>{gettext('LOADING')}</p>;

    return (
        <Table
            header={[gettext('NAME'), gettext('ACTIONS')]}
            rows={manager.walkthroughs.map((walkthrough) => [
                { value: walkthrough.getNameTranslated() },
                {
                    value: walkthrough.isOpen() ? (
                        <UpdateStatusLink
                            walkthrough={walkthrough}
                            status="CANCELED"
                            text={gettext('STOP')}
                        />
                    ) : (
                        <UpdateStatusLink
                            walkthrough={walkthrough}
                            status="OPEN"
                            text={gettext('START')}
                        />
                    ),
                },
            ])}
        />
    );
}
App.propTypes = {
    manager: PropTypes.object.isRequired,
};

function walkthroughPage() {
    const manager = getGlobalWalkthroughManager();

    // For more details see: https://facebook.github.io/react/docs/top-level-api.html#react.render
    const container = document.getElementById('my-view');
    const root = createRoot(container);
    root.render(<App manager={manager} />);
}

export default walkthroughPage;
